import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { APIService } from '../services/APIService';
import { LocalUtilService } from '../services/local-util.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.css'],
    standalone: false
})
export class UserComponent extends APIService {

  constructor(public localService: LocalUtilService,
    location: Location, 
    router: Router, translateService: TranslateService) { 
    super(localService, location, router, translateService);
  }

}